<template>
	<inertia-head title="REITs Table" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">REIT Table</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Investing in REITs has never been easier. Our easy-to-use REITs table will help you pick the right ones, quickly and effortlessly. Get the inside scoop on which REITs to buy and forget about doing extensive research. Save time and money whilst still earning fixed income with our comprehensive REITs table now!
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<div v-if="user.current_rank === 'SILVER'">
					<div class="alert alert-warning">
						<p class="mb-0 fw-semibold">
							UPGRADE to GOLD or HIGHER to view REIT TABLE.
						</p>
					</div>
				</div>
				<div v-else>
					<div class="table-responsive">
						<table class="table table-striped table-borderless table-vcenter fs-sm">
							<thead>
								<tr>
									<th>Stock Code</th>
									<th>Company Name</th>
									<th class="text-end">Recommendation</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(reit, index) in reitTable" :key="reit.fundcode">
									<td nowrap="">
										<inertia-link v-if="reit.has_details>0" href="#" @click="viewDetails(reit.fundcode)" class="fw-bold text-info" title="View the details">{{reit.fundcode}}</inertia-link>
										<inertia-link v-if="reit.has_details<=0" href="#" class="fw-bold text-secondary" title="No Details">{{reit.fundcode}}</inertia-link>
									</td>
									<td>{{reit.fund}}</td>
									<td class="text-end">
										<span class="fw-semibold" 
											:class="{
												'text-success':reit.actiontotake=='Continue Buying',
												'text-danger':reit.actiontotake=='Stop Buying',
												'text-elagance':reit.actiontotake=='Sell',
												'text-warning':reit.actiontotake=='Hold'
											}"
											>
											<small>{{reit.actiontotake}}</small>
										</span>
									</td>
								</tr>
								<tr v-if="reitTable.length == 0">
									<td colspan="3">
										<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					
				</div>
			</div>
		</div>
	</div>

	<recommendations-modal
	ref="recommendationsModal"
	:stockDetails="stockDetails"
	></recommendations-modal>

</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted, ref, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import AuthLayout from '../../../Layouts/AuthLayout';
import RecommendationsModal from '../../../Components/Member/RecommendationsModal';

export default {
	layout: AuthLayout,
	props: {
		user			: Object,
		reitTable		: Object,
		stockDetails 	: Object
	},
	components:{
		RecommendationsModal
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const recommendationsModal 	= ref(null);

		const viewDetails = (_stock)=>{

			Inertia.get(
				'/member/recommendations/reits?stock='+_stock,{},
				{
					// replace: true,
					preserveState: true,
					preserveScroll: true,
					only:['stockDetails']
				}
			)

			recommendationsModal.value.toggleModal();
		}

		return{
			recommendationsModal,
			viewDetails
		}
	},
}
</script>
